<template>
  <listing-layout :style="{ '--apperances-color': appearances && appearances.schema_color ? appearances.schema_color : 'var(--primary)' }" no-sm-padding>
    <div slot="heading" class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="nominate__title h2 mb-3">In-progress and Past Drafts</h1>
    </div>
    <div slot="content" class="leaders">
      <div class="leaderboard nominate bg-white rounded">
        <div class="alert alert-success" v-if="success">{{success}}</div>

        <appearances-drafts-header :appearances="appearances"/>

        <div class="__container nominate__item _type-other-drafts">

          <appearances-drafts-desktop-banner :appearances="appearances" />

          <div v-for="draft in draftsList" :key="draft.id" class="draft">
            <div class="nominate__item-wrap-name">
              {{ draft.name }}
            </div>
            Starts: {{ formatDate(draft.start_date) }}
            <router-link
              :to="{
                name: 'LeadersDraft',
                params: { draft_id: draft.id }
              }"
              class="nominate__click btn btn-outline-primary btn-sm btn-block"
              :style="{ '--apperances-color': appearances.schema_color || 'var(--primary)' }"
            >
              View results
            </router-link>
          </div>
        </div>
        <div class="footer">
          <!-- need add banner -->
        </div>
      </div>
    <pagination   
      v-if="totalPages"
      :page="currentPage"
      :total-pages="totalPages"
      :on-change="handlePageChange"
      :color="appearances.schema_color"
      class="paginate-leaderboard"
      />
    </div>
  </listing-layout>
</template>

<script>
import listingLayout from '@/components/ListingLayout'
import pagination from '@/components/Pagination'
import axios from 'axios'
import getAppearances from './mixins/getAppearances'
import AppearancesDraftsHeader from './components/AppearancesDraftsHeader'
import AppearancesDraftsDesktopBanner from './components/AppearancesDraftsDesktopBanner'

export default {
  name: 'LeadersDrafts',
  mixins: [getAppearances],
  props: ['success'],
  components: {
    AppearancesDraftsHeader,
    AppearancesDraftsDesktopBanner,
    'listing-layout': listingLayout,
    pagination
  },
  data() {
    return {
      draftsList: [],
      error: null,
      options: {
        loaded: false
      },
      currentPage: null,
      totalPages: null
    }
  },
  methods: {
    getDraftsList() {
      axios.get(`${this.$api}/leaders/drafts`, {
        params: {
          page: this.currentPage
        }
      }).then((response) => {
        if (response.data.status === 'success') {
          this.draftsList = response.data.data.drafts
          this.totalPages = response.data.meta.last_page
        } else {
          this.error = 'Unable to receive data from the server. Please reload the page.'
        }
        this.options.loaded = true
      })
    },
    handlePageChange(page) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page
        }
      })
    },
    formatDate(dateStr) {
      const date = new Date(dateStr)
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })
    }
  },
  watch: {
    '$route.query.page': {
      immediate: true,
      handler(page) {
        this.currentPage = Number(page) || 1
        this.getDraftsList()
      }
    }
  }
}
</script>
<style scoped>
  .nominate__title {
    color: var(--apperances-color) !important;
  }

  .nominate__click {
    border-color: var(--apperances-color) !important;
    color: var(--apperances-color) !important;
    background-color: white !important;
  }

  .nominate__click:hover {
    color: white !important;
    background-color: var(--apperances-color) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Leaders/Listing/Drafts.vue